import React from "react";
import { Link } from "./../util/router";

function AuthFooter(props) {
  return (
    <div
      className={
        "px-3 mt-6 text-sm text-center" +
        (props.className ? ` ${props.className}` : "")
      }
    >
      {props.type === "signup" && (
        <>
          {props.showAgreement && (
            <div className="mb-3">
              By signing up, you are agreeing to our{" "}
              <Link to={props.termsPath} className="text-green-700">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link to={props.privacyPolicyPath} className="text-green-700">
                Privacy Policy
              </Link>
              .
            </div>
          )}

          {props.signinText}
          <Link to={props.signinPath} className="ml-3 text-green-700">
            {props.signinAction}
          </Link>
        </>
      )}

      {props.type === "signin" && (
        <>
          <Link to={props.signupPath} className="text-green-700">
            {props.signupAction}
          </Link>

          {props.forgotPassAction && (
            <Link to={props.forgotPassPath} className="ml-4 text-green-700">
              {props.forgotPassAction}
            </Link>
          )}
          <div className="mt-3">
              By continuing to use our services, you are agreeing to our{" "}
              <Link to={props.termsPath} className="text-green-700">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link to={props.privacyPolicyPath} className="text-green-700">
                Privacy Policy
              </Link>
              .
            </div>
        </>
      )}

      {props.type === "forgotpass" && (
        <>
          {props.signinText}
          <Link to={props.signinPath} className="ml-3 text-green-700">
            {props.signinAction}
          </Link>
        </>
      )}
    </div>
  );
}

export default AuthFooter;
